import React from "react";

import TreeScreen from "./TreeScreen";

export default function ProductsScreen(props) {
  return <TreeScreen {...props} treeRoot="products" editable={true} />;
}
